module.exports = __webpack_public_path__ + "img/birthday.607bb9ec.svg";